import { getNotificationState } from 'common/header/notifications/hooks/mappers/impl/shared';
import { type NotificationMapper } from 'common/header/notifications/Notifications.types';

export const taskAssignedMapper: NotificationMapper = (notification, options) => {
  const { isReady } = getNotificationState(notification.status);
  return {
    ...notification,
    title: options.intl.taskAssignedToYouTitle,
    description: options.intl.taskAssignedToYouDescription,
    to: isReady ? `/${options.tenantCode}/tasks/edit/${notification.resourceUid}` : undefined
  };
};
